export default "__VITE_ASSET__TXh81JMr__"